export default __webpack_public_path__ + "static/products-mb-clear-chile-eeff9a5e68e61eda90b38c21798d6731.png";